import { DocumentInterface } from '../interfaces/document';
import { Inspection } from "./inspection";

export class Document implements DocumentInterface {
    id_document?: number;
    fk_id_inspection: number;
    inspection: Inspection;
    name: string;
    type: string;

    constructor() {
        this.fk_id_inspection = 0;
        this.inspection = new Inspection();
        this.name = '';
        this.type = '';
    }
}